var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompletedIndicatorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_331_934",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 16,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00015 2.98758e-05C6.94776 -0.00647598 5.90454 0.195999 4.931 0.595733C3.95746 0.995466 3.07296 1.58448 2.3288 2.32864C1.58463 3.07281 0.995604 3.9574 0.59587 4.93094C0.196137 5.90448 -0.00635392 6.94764 0.000151935 8.00003C-0.00635392 9.05242 0.196137 10.0956 0.59587 11.0691C0.995604 12.0427 1.58463 12.9272 2.3288 13.6714C3.07296 14.4156 3.95746 15.0046 4.931 15.4043C5.90454 15.8041 6.94776 16.0065 8.00015 16C9.05254 16.0065 10.0958 15.8041 11.0693 15.4043C12.0428 15.0046 12.9273 14.4156 13.6715 13.6714C14.4157 12.9272 15.0047 12.0427 15.4044 11.0691C15.8042 10.0956 16.0067 9.05242 16.0002 8.00003C16.0067 6.94764 15.8042 5.90448 15.4044 4.93094C15.0047 3.9574 14.4157 3.07281 13.6715 2.32864C12.9273 1.58448 12.0428 0.995466 11.0693 0.595733C10.0958 0.195999 9.05254 -0.00647598 8.00015 2.98758e-05ZM8.00015 14.8571C6.18318 14.8518 4.44214 14.1276 3.15735 12.8428C1.87255 11.558 1.14843 9.817 1.14316 8.00003C1.14843 6.18306 1.87255 4.44205 3.15735 3.15726C4.44214 1.87246 6.18318 1.14825 8.00015 1.14297C9.81712 1.14825 11.5582 1.87246 12.843 3.15726C14.1278 4.44205 14.8519 6.18306 14.8571 8.00003C14.8519 9.817 14.1278 11.558 12.843 12.8428C11.5582 14.1276 9.81712 14.8518 8.00015 14.8571ZM6.85715 11.2L4.00015 8.34305L4.91415 7.42899L6.85715 9.37198L11.0862 5.14297L12.0002 6.05704L6.85715 11.2Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_331_934)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_331_934",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: -2,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.14258 17.1431H17.1434V-1.14294H-1.14258V17.1431Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_331_934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.71387 -5.71399H21.7151V21.714H-5.71387V-5.71399Z",
    fill: "#368A04"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedIndicatorIcon);
export default __webpack_public_path__ + "static/media/CompletedIndicatorIcon.e110486932b48037f482a3ee048a21b2.svg";
export { ForwardRef as ReactComponent };